export const addSecond = (time: string) => {
  let [hh, mm, ss] = time.split(":").map(Number);
  if (!ss) {
    ss = 0;
  }
  let totalSeconds = hh * 3600 + mm * 60 + ss + 1;

  // Reinicia después de 23:59:59
  totalSeconds %= 24 * 3600;

  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
    2,
    "0",
  );
  const seconds = String(totalSeconds % 60).padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
};
